import { ReactNode, createContext, useEffect, useState } from 'react'

import { flushCurrentSession } from '../../services/sessionService'
import getCurrentSession from '../../services/sessionService'

export type Props = {
	deviceType: 'mobile' | 'desktop'
	loadingSession: boolean
	toggleFavourite(trackId: number): void
	clearAllFavourites(): void
} & Session

interface SessionProviderProps {
	children: ReactNode
}

export const SessionContext = createContext<Props | undefined>(undefined)
const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
	const [deviceType, setDeviceType] = useState<'mobile' | 'desktop'>('desktop')
	const [loadingSession, setLoadingSession] = useState(true)
	const [session, setSession] = useState<Session>({
		user: null,
		expires: null,
	} as Session)

	const fetchSession = async (): Promise<void> => {
		const sessionData = await getCurrentSession()
		setSession(sessionData)
		setLoadingSession(false)
	}
	useEffect(() => {
		fetchSession()

		return () => {
			setSession(null)
		}
	}, [])

	useEffect(() => {
		setDeviceType(
			window.matchMedia('(hover: none)').matches ||
				window.matchMedia('(any-hover: none)').matches ||
				window.matchMedia('(pointer: coarse)').matches ||
				window.matchMedia('(any-pointer: coarse)').matches
				? 'mobile'
				: 'desktop'
		)
	}, [])

	const toggleFavourite = (trackId: number): void => {
		flushCurrentSession()
		const {
			user: { favouriteTracks },
		} = session

		const isFavourite = favouriteTracks.some(
			(favouriteTrackId) => favouriteTrackId === trackId
		)

		if (isFavourite) {
			setSession({
				...session,
				user: {
					...session.user,
					favouriteTracks: favouriteTracks.filter(
						(favouriteTrackId) => favouriteTrackId !== trackId
					),
				},
			})
		} else {
			setSession({
				...session,
				user: {
					...session.user,
					favouriteTracks: [...favouriteTracks, trackId],
				},
			})
		}
	}

	const clearAllFavourites = (): void => {
		flushCurrentSession()

		setSession({
			...session,
			user: {
				...session.user,
				favouriteTracks: [],
			},
		})
	}

	const value = {
		...session,
		deviceType,
		loadingSession,
		toggleFavourite,
		clearAllFavourites,
	}

	return (
		<SessionContext.Provider value={value}>{children}</SessionContext.Provider>
	)
}

export default SessionProvider
